EmailFormTextInputView = require('./text_input_view')

class EmailFormTextLineInputView extends EmailFormTextInputView
  tagName: 'li'

  events:
    'keyup .text_line_input': 'validateEmailForm'

  initialize: ->
    EmailFormTextInputView::initialize.apply(this, arguments)
    @elementID = ".text_line_input"
    @template = {text_line_input_template: true}

module.exports = EmailFormTextLineInputView
